import { MifeParcel } from '@/components/MifeParcel';
import { createFileRoute } from '@tanstack/react-router';

// TT-260/TT-267: mounts the version-one parcel for a product detail page reached
// by response key (/investments/waqf today, Waqf Donations next). The Vue router
// owns the page; this host route exists only so the React shell resolves the path,
// the same reason wakala.tsx exists.
export const Route = createFileRoute('/_authenticated/_pfida/investments/$sourceKey')({
  component: () => <MifeParcel />,
});
